import {
    IonAvatar,
    IonCol, 
    IonIcon,
    IonImg,
    IonItem,
    IonLabel,
    IonNote,
    IonRow,
    IonThumbnail,
    IonText,
    IonRippleEffect
} from '@ionic/react';
import { heart, chevronForwardOutline } from 'ionicons/icons';
import { ItemInfo, ItemInfoProp } from '../data/item';
import React, { Component }  from 'react';


  
const EmoComp: React.FC<ItemInfoProp> = ({ item, submit }) => {
    return (
        <IonItem className="ion-activatable ripple-parent" lines="none" color="none" onClick={ ()=> submit(item) }>
            <IonAvatar slot="start">
                <img src={item.avatar} onError={ ({currentTarget}) => { currentTarget.src = '/assets/img/avt.jpg' } } />
            </IonAvatar>
            <IonLabel className="ion-text-wrap">
                <h2>{item.name}</h2>
            </IonLabel>
            <div className="like-counter" slot="end">
                <IonText className="msg-emo-but">{item.info}</IonText>
            </div>
            <IonRippleEffect></IonRippleEffect>
        </IonItem>
    );
};
  
export default EmoComp;